export default "__VITE_ASSET__BXFVzMr1__"